<template>
   
    <div class="container md:mt-24 mt-16">
                
        <div class="grid grid-cols-1 pb-8 text-center">
            <SectionTitleComponent :title="'Over ons'" />
        </div>

        <div class="grid lg:grid-cols-3 md:grid-cols-1 sm:grid-cols-1 grid-cols-1 mt-2 gap-12 text-zinc-700">
            <div class="text-center">
                <p class="font-bold text-3xl">Kwaliteit</p>
                <p class="text-lg mt-3">Hoge standaard van zorg en expertise in alles wat we doen</p>
            </div>
            <div class="text-center">
                <p class="font-bold text-3xl text-amber-400">Betrokkenheid</p>
                <p class="text-lg mt-3">Met persoonlijke aandacht werken we samen aan jouw doelen</p>
            </div>
            <div class="text-center">
                <p class="font-bold text-3xl">Duurzaam</p>
                <p class="text-lg mt-3">Met het oog op blijvend resultaat op lange termijn</p>
            </div>
        </div>

        <div class="grid md:grid-cols-12 grid-cols-1 items-center gap-[30px] mt-12">
            <div class="lg:col-span-5 md:col-span-6">
                <div class="relative">
                    <div class="grid grid-cols-12 gap-6 items-center">
                        <div class="col-span-6">
                            <div class="grid grid-cols-1 gap-6">
                                <img src="../assets/images/visie/1.jpg" class="shadow rounded-md" alt="">
                                <img src="../assets/images/visie/2.jpg" class="shadow rounded-md" alt="">
                            </div>
                        </div>

                        <div class="col-span-6">
                            <div class="grid grid-cols-1 gap-6">
                                <img src="../assets/images/visie/3.jpg" class="shadow rounded-md" alt="">
                            </div>
                        </div>
                    </div>   
                </div>
            </div>

            <div class="lg:col-span-7 md:col-span-6 group relative overflow-hidden shadow-lg rounded-lg transition text-justify py-6">
                <div class="m-8 md:ms-16 md:me-12 text-zinc-700">
                    <h3 class="mb-6 md:text-4xl text-3xl md:leading-normal leading-normal font-bold"><span class="text-amber-300">Impuls</span> Kinesitherapie</h3>

                    <p class="max-w-xl">
                        Bij onze praktijk staan kwaliteit, betrokkenheid en duurzaamheid centraal. Onze missie is eenvoudig: mensen weer <span class="text-amber-400 text-lg">in beweging</span> krijgen! We willen pijnklachten verhelpen en mensen begeleiden naar een fitter en gezonder leven. 
                    </p> 

                    <p class="mt-2 text-center">
                        <span class="text-amber-400 text-lg">"Wij zijn de impuls voor verandering."</span>
                    </p>
                    
                    <p class="mt-2">
                        We benaderen jouw klachten of doelen met een <i>open mind</i> en stellen een persoonlijk stappenplan op. Geen giswerk, maar een degelijk gestructureerd onderzoek en regelmatige evaluaties vormen de basis van ons plan. We geloven in het proces van samenwerken - <span class="text-amber-400 text-lg">jij bent de drijvende kracht</span> achter je eigen succes, en wij begeleiden je elke stap van de weg.
                    </p>
                    <p class="mt-2">    
                        We zijn oprecht geïnteresseerd in jouw doelen en werken samen met jou aan het realiseren ervan. Jouw <span class="text-amber-400 text-lg">vooruitgang is onze prioriteit</span>, en we blijven continu investeren in onze kennis en vaardigheden, zodat we jou altijd de beste begeleiding kunnen bieden.
                    </p>
                    <p class="mt-2">
                        Onze visie voor de toekomst is om zoveel mogelijk mensen te helpen een gezonder leven te leiden, vrij van klachten, en hen de kracht te geven om weer te <span class="text-amber-400 text-lg">genieten van beweging</span>. We geloven dat iedereen in staat is om de controle over zijn of haar gezondheid terug te nemen, en we zijn er om dat proces te ondersteunen en te begeleiden.
                    </p>
                
                    <div class="mt-6">
                        <router-link to="/contact" class="btn bg-amber-300 hover:bg-amber-300 border-amber-300 hover:border-amber-300 text-black mt-2 rounded-md"><i class="uil uil-envelope"></i> Contacteer ons</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import SectionTitleComponent from '@/components/SectionTitleComponent.vue';

export default {
    components: {
        SectionTitleComponent
    },
    data() {
        return {
            isActive: false,
        }
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>

</style>